import * as React from 'react';
import * as ReactDOM from 'react-dom';
import Conjure from '@blizzard/conjure';
import ErrorBoundary from '../components/ErrorBoundary';

function init(locale, project, page, env) {
    ReactDOM.render((
        <ErrorBoundary env={env}>
            <Conjure locale={locale} project={project} page={page} env={env} loadingState={<div style={{height: "878.156px"}}/>}
                     testEnv={env === "dev"}/>
        </ErrorBoundary>
    ), document.querySelector('.cauldron-app'));
}

init(window.blizzard.sc2.locale, window.blizzard.sc2.cauldronProject, window.blizzard.sc2.cauldronPage, window.blizzard.sc2.cauldronEnv);
